<template>
  <div class="background_all">
    <div class="background">
      <img style="height: 60px;" src="@/images/u429.png" alt="">
      <div class="vertical-shu"></div>
      <div class="contact-info">
        <span class="vertical-text">联系我们</span>
        <span class="text_cont">电话：0571-87959195</span>
        <span class="text_cont">地址：杭州市上城区源聚路299号钱涌白石中心2幢806室</span>
        <span class="text_cont">邮箱：hzgf@digit-core.com</span>
      </div>
  
      <div class="vertical-shu"></div>
      <div class="follow-us">
        <img style="width:100px;height:auto;" src="@/images/18db84ba8368003d7a6e1210470c05c9.jpg" alt="">
        <span>扫一扫 关注我们</span>
      </div>
    </div>
  
  
  
  
    <div>
      <div class="hang">
  
      </div>
      <div class="center-content">
        
       
        <span class="ver_text">© 2025 杭州古峰智能科技有限公司版权所有</span>
        <a class="ver_text" style="text-decoration: none;"
          href="https://beian.miit.gov.cn/#/Integrated/index">&nbsp&nbsp&nbsp&nbsp
          浙ICP备16019104号-3&nbsp&nbsp&nbsp&nbsp</a>
        <a class="ver_text" style="text-decoration: none;"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=33010802008258">
          <img style="width:16px;height:16px;" src="@/images/ico/image.png" alt="">浙公网安备33010802008258号
        </a>
        <a class="ver_text" href="https://xyt.xcc.cn/getpcInfo?sn=1947234672261922816&language=CN&certType=8&url=*.shuheyun.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
          <div style="width:100%;height:100%;position: absolute;"></div>
          <embed src="https://www.shuheyun.com/shuheyun.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a>
       
      </div>
    </div>
  
  </div>
 
</template>

<script>

export default {


}
</script>

<style scoped>
.background {

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 20px;
  box-sizing: border-box;
}

.background_all {
  background-color: #e7e7e784;
}

.hang {
  margin: 0 auto;
  background-color: rgb(133, 133, 133);
  height: 0.5px;
  width: 60%;
}

/* .vertical-shu {
  background-color: rgb(133, 133, 133);
  height: 120px;
  width: 0.5px;
  margin: 0 20px;
} */

.center-content {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.contact-info {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.follow-us {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.center-content .ver_text {
  font-size: 14px;
  color: #333;
  margin: 5px 0;
}

.contact-info .vertical-text {
  font-size: 22px;
  letter-spacing: 8px;
  margin-bottom: 10px;
}

.text_cont {
  font-size: 16px;
  color: #333;
  margin: 2px 0;
}

.follow-us img {
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .background {
    flex-direction: column;
    padding: 10px;
  }

  .vertical-shu {
    display: none;
  }
}
</style>